module.exports = __webpack_public_path__ + "assets/img/scss_no_select.b8feb703.jpg";